import React from 'react'
import { Badge } from '@/components/ui/Badge'
import type { SuggestionSourceType } from '../types/mrpTypes'

export interface MrpSuggestionSourceBadgeProps {
  source?: SuggestionSourceType | null
  className?: string
}

/**
 * Distinct badge representation for suggestion sources:
 * MRP (dynamic demand-driven calculation) vs POLICY (static min/max reorder point).
 * Ensures they are never visually merged into the same logical suggestion.
 */
export function MrpSuggestionSourceBadge({
  source,
  className = '',
}: MrpSuggestionSourceBadgeProps): React.ReactElement | null {
  if (!source) return null

  if (source === 'MRP') {
    return (
      <Badge
        tone="info"
        className={`font-semibold ${className}`}
        title="Đề xuất sinh từ tính toán cân đối nhu cầu sản xuất (MRP)"
      >
        <span className="h-1.5 w-1.5 rounded-full bg-sky-500" />
        Đề xuất mua (MRP)
      </Badge>
    )
  }

  if (source === 'POLICY') {
    return (
      <Badge
        tone="warning"
        className={`font-medium ${className}`}
        title="Đề xuất sinh từ định mức tồn an toàn / Điểm đặt hàng lại (Policy)"
      >
        <span className="h-1.5 w-1.5 rounded-full bg-amber-500" />
        Định mức tồn (Policy)
      </Badge>
    )
  }

  return (
    <Badge tone="neutral" className={className} title="Đề xuất thủ công">
      Thủ công
    </Badge>
  )
}
